export default "__VITE_ASSET__1228abe7__"